import axios from "axios";

const UpdateAxios = (props = {}) => {
  var gett = localStorage.getItem("isloggedIn");
  var customerNo = localStorage.getItem("customerNumber");
  var userId = localStorage.getItem("userId");
  var locales = localStorage.getItem("locales") === "en" ? "en-IN" : "pt-Br"
  let congData = JSON.stringify({
    customerNumber: customerNo,
    userId: userId,
    customerNo: +customerNo,
    customer_no: +customerNo,
    user_id: +userId,
    ...props.payload,
  });

  const apiURL = props.completeURL
    ? `${props.completeURL}`
    : props.uniqueId ? `${process.env.REACT_APP_MASTER_API}/${props.url}/${props.uniqueId}` : `${process.env.REACT_APP_MASTER_API}/${props.url}`;

  if (props.completeURL) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .put(apiURL, congData, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `${gett}`,
              "Accept-Language": locales
            },
          })
          .then((res) => {
            // console.log("created", res);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  }
  else if (props.patchURL) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .patch(props.patchURL, congData, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `${gett}`,
              "Accept-Language": locales
            },
          })
          .then((res) => {
            // console.log("created", res);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  }
  else {
    try {
      return new Promise((resolve, reject) => {
        axios
          .patch(apiURL, congData, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `${gett}`,
              "Accept-Language": locales
            },
          })
          .then((res) => {
            // console.log("created", res);
            if (res.data.status === 200 || res.data.status === 1) {
              resolve(res);
            } else {
              reject(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  }
};

export default UpdateAxios;
